/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Translation_Jobs_Started_ToastInputs */

const en_translation_jobs_started_toast = /** @type {(inputs: Translation_Jobs_Started_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Successfully started ${i?.count} translation job(s). View Translation Import dashboard for more information. (AI Tools -> Translation Import)`)
};

const fr_translation_jobs_started_toast = /** @type {(inputs: Translation_Jobs_Started_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Démarrage réussi de ${i?.count} tâche(s) de traduction. Consultez le tableau d’importation des traductions pour plus d’informations. (Outils IA -> Importation de traduction)`)
};

const de_translation_jobs_started_toast = /** @type {(inputs: Translation_Jobs_Started_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Übersetzungsaufträge (PH_0__) wurden erfolgreich gestartet. Weitere Informationen finden Sie im Dashboard „Übersetzungsimport“. (KI-Tools -> Übersetzungsimport)`)
};

const it_translation_jobs_started_toast = /** @type {(inputs: Translation_Jobs_Started_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Avviati con successo ${i?.count} lavori di traduzione. Per ulteriori informazioni, consultare la dashboard di importazione delle traduzioni. (Strumenti AI -> Importazione traduzioni)`)
};

const ru_translation_jobs_started_toast = /** @type {(inputs: Translation_Jobs_Started_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Задание(я) перевода ${i?.count} успешно запущено. Для получения дополнительной информации перейдите на панель управления импортом переводов. (Инструменты ИИ -> Импорт переводов)`)
};

const es_translation_jobs_started_toast = /** @type {(inputs: Translation_Jobs_Started_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se iniciaron correctamente ${i?.count} trabajos de traducción. Consulte el panel de Importación de traducciones para obtener más información. (Herramientas de IA -> Importación de traducciones)`)
};

const zh_cn2_translation_jobs_started_toast = /** @type {(inputs: Translation_Jobs_Started_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已成功启动 ${i?.count} 翻译任务。请查看翻译导入控制面板了解更多信息。（AI 工具 -> 翻译导入）`)
};

const ja_translation_jobs_started_toast = /** @type {(inputs: Translation_Jobs_Started_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 件の翻訳ジョブを正常に開始しました。詳細については、翻訳インポートダッシュボードをご覧ください。(AIツール -> 翻訳インポート)`)
};

const hi_translation_jobs_started_toast = /** @type {(inputs: Translation_Jobs_Started_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} अनुवाद कार्य सफलतापूर्वक शुरू हो गया है। अधिक जानकारी के लिए अनुवाद आयात डैशबोर्ड देखें। (एआई टूल्स -> अनुवाद आयात)`)
};

const pt_pt2_translation_jobs_started_toast = /** @type {(inputs: Translation_Jobs_Started_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trabalho(s) de tradução ${i?.count} iniciado(s) com sucesso. Consulte o painel de Importação de Traduções para obter mais informações. (Ferramentas de IA -> Importação de Traduções)`)
};

/**
* | output |
* | --- |
* | "Successfully started {count} translation job(s). View Translation Import dashboard for more information. (AI Tools -> Translation Import)" |
*
* @param {Translation_Jobs_Started_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_jobs_started_toast = /** @type {((inputs: Translation_Jobs_Started_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Jobs_Started_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_translation_jobs_started_toast(inputs)
	if (locale === "de") return de_translation_jobs_started_toast(inputs)
	if (locale === "it") return it_translation_jobs_started_toast(inputs)
	if (locale === "ru") return ru_translation_jobs_started_toast(inputs)
	if (locale === "es") return es_translation_jobs_started_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_translation_jobs_started_toast(inputs)
	if (locale === "ja") return ja_translation_jobs_started_toast(inputs)
	if (locale === "hi") return hi_translation_jobs_started_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_translation_jobs_started_toast(inputs)
	return en_translation_jobs_started_toast(inputs)
});